import React from 'react';

import useService from '../core/ServiceRegistry';

export function useURLBuilder() {
  const language = useService('language');
  const { current, disableUrlPatching } = language;
  return (route, params, search = {}) => {
    const searchString = Object.entries(search)
      .map(([key, value]) => {
        const encKey = encodeURIComponent(String(key));
        const encVal = value === undefined || value === null ? '' : encodeURIComponent(String(value));
        return `${encKey}=${encVal}`;
      })
      .join('&');
    const preparedSearchString = searchString ? `?${searchString}` : '';
    const routePath = typeof route === 'object' ? route.path : route;
    const routePathWithSearch = `${routePath !== '/' ? routePath : ''}${preparedSearchString}`;
    return disableUrlPatching ? `/${routePathWithSearch}` : `/${current}/${routePathWithSearch}`;
  };
}
